/**
 * Stable color from a string — used so contacts/agents get a consistent
 * avatar color across the app without us having to round-trip backend data.
 */
const PALETTE = ['#FF5A1F', '#1E7BFF', '#7A3CFF', '#F000D8', '#2ECC5A', '#FF7A3C', '#F2A900'];

export function colorFromName(name?: string | null): string {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function initialsFromName(name?: string | null): string {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
